export function Error404Page() {
  return <h1>404</h1>
}
